import {
  Button,
  Callout,
  FormLayout,
  GridFieldGroup,
  Heading,
  Paragraph,
  SyntaxIcon,
  TextInput,
} from '@expressable/syntax-ds';
import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { EvaluationFormType } from 'domains/signupDirect/schemas/evaluationSchema';
import { HeadingCombo } from 'domains/signupDirect/SyntaxComps/HeadingCombo';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ManualPCPEntry: React.FC<{
  onBailoutNoPCP: () => void;
  onBackToSearch: () => void;
}> = ({ onBailoutNoPCP, onBackToSearch }) => {
  const { t } = useTranslation();
  const { register } = useFormContext<EvaluationFormType>();

  return (
    <>
      <FormLayout.Fields className="mobile-xs-d:gap-e24 tablet-d:gap-e32">
        <HeadingCombo>
          <Heading noDefaultMargins level="h5">
            {t('directSignup.NPILookup.title')}
          </Heading>
          <Paragraph variant="secondary" size="md">
            {t('directSignup.NPILookup.subTitle')}
          </Paragraph>
        </HeadingCombo>
        <Callout type="info">{t('directSignup.NPILookup.callout')}</Callout>

        <TextInput
          data-testid="primary-physician-name-input"
          label={t('directSignup.manualPCP.labels.name')}
          {...register('primaryPhysician.fullName')}
        />
        <TextInput
          data-testid="primary-physician-office-name-input"
          label={t('directSignup.manualPCP.labels.address')}
          hint={t('directSignup.manualPCP.labels.addressHint')}
          {...register('primaryPhysician.office')}
        />

        <GridFieldGroup>
          <TextInput
            data-testid="primary-physician-phone-input"
            label={t('directSignup.manualPCP.labels.phone')}
            type="tel"
            {...register('primaryPhysician.phone')}
          />
          <TextInput
            data-testid="primary-physician-email-input"
            label={t('directSignup.manualPCP.labels.website')}
            type="url"
            {...register('primaryPhysician.website')}
          />
        </GridFieldGroup>
      </FormLayout.Fields>
      <FormLayout.CTA>
        <Button data-testid="back-to-search-button" variant="secondary" onClick={onBackToSearch}>
          <SyntaxIcon icon={MagnifyingGlassIcon} />
          {t('directSignup.manualPCP.cta.backToSearch')}
        </Button>
        <Button data-testid="no-pcp-button" variant="link" onClick={onBailoutNoPCP}>
          {t('directSignup.manualPCP.cta.noPhysicianInfo')}
        </Button>
      </FormLayout.CTA>
    </>
  );
};

export default ManualPCPEntry;
